import { render, staticRenderFns } from "./polymers-music.vue?vue&type=template&id=1ede55b4&scoped=true"
import script from "./polymers-music.vue?vue&type=script&lang=js"
export * from "./polymers-music.vue?vue&type=script&lang=js"
import style0 from "./polymers-music.vue?vue&type=style&index=0&id=1ede55b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ede55b4",
  null
  
)

export default component.exports